import React from "react";
import styles from "./Footer.module.scss";
import { Link } from "react-router-dom";
import useFooterLogic from "./Footer.logic";
import { formatDate, formatTime } from "../../utils/dateUtils";

const Footer: React.FC = () => {
  const { events, contactDetails } = useFooterLogic();

  return (
    <>
      {/* Site Footer Start */}
      <footer className="site-footer-two">
        {/* <div className="site-footer-two__top">
          <div className="container">
            <div className="site-footer-two__top-inner">
              <Link to="/events" className="site-footer-two__top-content">
                Join The <span>Event Now</span>{" "}
                <i className="icon-arrow-up"></i>
              </Link>
            </div>
          </div>
        </div> */}
        <div className="site-footer-two__middle">
          <div className="container">
            <div className="site-footer-two__middle-inner">
              <div className="row">
                <div
                  className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp"
                  data-wow-delay="200ms"
                >
                  <div className="footer-widget__column footer-widget-two__about">
                    <div className="site-footer-two__logo">
                      <Link to="/">
                        {/* <img
                          src="/assets/images/resources/site-footer-logo-2.png"
                          alt=""
                        /> */}
                        <span className="logo_name">ImpactUp</span>
                        <span className="slogan_name">
                          Where Passion Meets Purpose.
                        </span>
                      </Link>
                    </div>
                    <p className="footer-widget-two__about-text">
                      Impact Up is a startup project driven by the idea that
                      passion can fuel purpose.
                    </p>
                    <div className="site-footer-two__social">
                      <a href="#">
                        <i className="icon-facebook"></i>
                      </a>
                      <a href="#">
                        <i className="icon-fi"></i>
                      </a>
                      <a href="#">
                        <i className="icon-instagram"></i>
                      </a>
                      {/* <a href="#">
                        <i className="icon-pinterest"></i>
                      </a> */}
                    </div>
                    <p className="site-footer-two__bottom-text mt-3">
                      © ImpactUp 2025 | All Rights Reserved
                    </p>
                  </div>
                </div>
                {/* <div
                  className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp"
                  data-wow-delay="200ms"
                >
                  <div className="footer-widget__column footer-widget__events">
                    <div className="footer-widget__title-box">
                      <h3 className="footer-widget__title">Upcoming Events</h3>
                    </div>
                    <ul className="footer-widget__events-list list-unstyled">
                      {events.map((event, index) => (
                        <li key={index}>
                          <p>
                            {formatDate(event.datetime)} at{" "}
                            {formatTime(event.datetime)} in{" "}
                            {event.location_city}
                          </p>
                          <h5>{event.title}</h5>
                          <Link to={`/events/${event.id}`}>
                            Join Now <span className="icon-arrow-right"></span>
                          </Link>
                        </li>
                      ))}
                      {events.length == 0 && (
                        <li>
                          <p className="mb-2">
                            No events are available right now. You can still
                            support our partnered NGOs by clicking the "Donate
                            Now" button. Stay tuned for updates on upcoming
                            events!
                          </p>
                          <Link to={`/ngos`}>Donate Now </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                </div> */}
                <div
                  className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp"
                  data-wow-delay="200ms"
                >
                  <div className="footer-widget__column footer-widget__link">
                    <div className="footer-widget__title-box">
                      <h3 className="footer-widget__title">Quick links</h3>
                    </div>
                    <ul className="footer-widget__link-list list-unstyled">
                      {/* <li>
                        <Link to="/">Home</Link>
                      </li>
                      <li>
                        <Link to="/events">Events</Link>
                      </li>
                      <li>
                        <Link to="/ngos">NGOs</Link>
                      </li>
                      <li>
                        <Link to="/about">About Us</Link>
                      </li>
                      <li>
                        <Link to="/contact">Contact Us</Link>
                      </li> */}
                      <li>
                        <Link to="/">Terms & Conditions</Link>
                      </li>
                      <li>
                        <Link to="/">Privacy Policy</Link>
                      </li>
                      <li>
                        <Link to="/">Contact Us</Link>
                      </li>
                    </ul>
                  </div>
                </div>

                <div
                  className="col-xl-5 col-lg-12 col-md-12 wow fadeInUp d-flex align-items-center"
                  data-wow-delay="200ms"
                >
                  <div className="site-footer-two__top-inner flex-fill">
                    <Link to="/events" className="site-footer-two__top-content">
                      Join The <span>Event Now</span>{" "}
                      <i className="icon-arrow-up"></i>
                    </Link>
                  </div>
                </div>


                {/* <div
                  className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp"
                  data-wow-delay="300ms"
                >
                  <div className="footer-widget__column footer-widget__contact">
                    <div className="footer-widget__title-box">
                      <h3 className="footer-widget__title">Contact</h3>
                    </div>
                    <div className="footer-widget__contact-inner">
                      <ul className="footer-widget__contact-list list-unstyled">
                        <li>
                          <div className="icon">
                            <span className="icon-envelop"></span>
                          </div>
                          <div className="text">
                            <p>
                              <a href={`mailto:${contactDetails.email}`}>
                                {contactDetails.email}
                              </a>
                            </p>
                          </div>
                        </li>
                        <li>
                          <div className="icon">
                            <span className="icon-pin"></span>
                          </div>
                          <div className="text">
                            <p>{contactDetails.address}</p>
                          </div>
                        </li>
                        <li>
                          <div className="icon">
                            <span className="icon-call"></span>
                          </div>
                          <div className="text">
                            <p>
                              <a href={`tel:${contactDetails.phone[0]}`}>
                                {contactDetails.phone.join(", ")}
                              </a>
                            </p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        {/* <div className="site-footer-two__bottom">
          <div className="container">
            <div className="site-footer-two__bottom-inner">
              <p className="site-footer-two__bottom-text">
                © ImpactUp 2025 | All Rights Reserved
              </p>
              <ul className="list-unstyled site-footer-two__bottom-menu">
                <li>
                  <Link to="/about">Terms & Conditions</Link>
                </li>
                <li>
                  <Link to="/about">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/about">Contact Us</Link>
                </li>
              </ul>
            </div>
          </div>
        </div> */}
      </footer>
      {/* Site Footer End */}
    </>
  );
};

export default Footer;
